import { useSendCommand } from '@/_core/cqrs/use';
import { Action } from '@/_core/fluxstore/types';
import { SaveViewOptions } from '../../../api/commands';
import { StorymapState, ViewType } from '../../types';
import { currentViewOptions } from '../../use';
import { useStorymapStore } from '../../useModule';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class SetShouldShowAssigneeBlock extends Action<StorymapState> {
    public static ACTION_TYPE = 'SetShouldShowAssigneeBlock';

    public constructor(public isEnabled: boolean) {
        super(SetShouldShowAssigneeBlock.ACTION_TYPE);
    }
}

const isAssigneeVisibilitySupported = (viewType: ViewType): boolean => viewType === ViewType.Planning || viewType === ViewType.Backlog;

const middleware = async (state: StorymapState, action: SetShouldShowAssigneeBlock): Promise<boolean> => {
    if (!isAssigneeVisibilitySupported(state.currentViewType)) {
        return true;
    }

    useSendCommand(action, {
        createCommand: () =>
            new SaveViewOptions(
                state.id,
                state.currentViewType,
                currentViewOptions.value.isShowPrioritization,
                currentViewOptions.value.isShowAnnotation,
                currentViewOptions.value.isShowPersonaBlock,
                currentViewOptions.value.isShowIssueType,
                action.isEnabled
            ),
    });

    return true;
};

const reducer = (state: StorymapState, action: SetShouldShowAssigneeBlock): void => {
    if (state.currentViewType === ViewType.Planning) {
        state.planningViewOptions.isShowAssignee = action.isEnabled;
    }

    if (state.currentViewType === ViewType.Backlog) {
        state.backlogViewOptions.isShowAssignee = action.isEnabled;
    }
};

//@ts-ignore
registerMiddleware(SetShouldShowAssigneeBlock.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(SetShouldShowAssigneeBlock.ACTION_TYPE, reducer);
